// extracted by mini-css-extract-plugin
export default {"modal":"DesktopStoreRatingModal_modal__vKU6-","container":"DesktopStoreRatingModal_container__D3o7A","likeAnimation":"DesktopStoreRatingModal_likeAnimation__NXNJL"};